export const CANAL_APP = "app";
export const URL_EMBEDDED_SOAT = "urlEmbeddedSoat";
